// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, boolean, string } from "@altostra/type-validations/lib/primitives";

export const isOAuthValidateDeveloperPermissionsResult = objectOf({
  missing_permissions: arrayOf(number),
  has_at_least_one_permission: boolean,
  approved_scopes: arrayOf(string),
  permissionless_scopes: arrayOf(string),
  missing_scopes: arrayOf(string),
});
